import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'collector-file',
  templateUrl: './collector-file.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectorFileComponent {

  constructor() { }

}
